import { render, staticRenderFns } from "./ProfileTalentThemes.vue?vue&type=template&id=1e11fc6b"
import script from "./ProfileTalentThemes.vue?vue&type=script&lang=js"
export * from "./ProfileTalentThemes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports